/** Écran de première connexion. */
export const CHEMIN_ACCUEIL = '/bienvenue';

/**
 * Faut-il intercaler l'écran d'accueil avant l'écran demandé ?
 *
 * Extrait du garde de route pour être testable sans navigateur, et parce que
 * la règle mérite d'être lisible d'un coup d'œil : on ne détourne qu'un
 * utilisateur connecté, qui n'a jamais vu l'écran, et qui ne s'y trouve pas
 * déjà — sans cette dernière condition, la redirection se rappellerait
 * elle-même sans fin.
 */
export function doitPasserParAccueil(user, chemin) {
  if (!user) return false;
  if (user.onboardingSeenAt) return false;
  return chemin !== CHEMIN_ACCUEIL;
}
